import React from 'react'
import classNames from 'classnames'

import { IconProps } from './Icon.schema'

const Icon = (props: IconProps): JSX.Element => {
    const className = classNames('icon', props.className)

    const href = `${process.env.NEXT_PUBLIC_URL || ''}/generated/icons.svg#${props.name}`

    return (
        <svg style={props.style} className={className}><use href={href}></use></svg>
    )
}

export default Icon